import { Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { SkeletonHandoffDirective } from '../../../directives/skeleton-handoff.directive';

/**
 * Loading placeholder for the data backend: mirrors the dark toolbar, the
 * fixed top bar and the 2x2 content grid (spatial levels, map, indicator and
 * data detail) of `AuthenticatedViewComponent`.
 */
@Component({
  selector: 'app-data-backend-skeleton',
  standalone: true,
  hostDirectives: [SkeletonHandoffDirective],
  imports: [SkeletonModule],
  templateUrl: './data-backend-skeleton.component.html',
  styleUrl: './data-backend-skeleton.component.scss',
})
export class DataBackendSkeletonComponent {
  /** Content size from `SidebarService.contentSize$()`: 'bigger' | 'smaller'. */
  @Input() size = 'bigger';
  /** Whether the indicator/data detail row is shown once loaded. */
  @Input() showIndicators = true;

  /** Label widths (rem) of the toolbar entries in the expanded navigation. */
  readonly toolbarItems = [6, 8, 7, 5, 6.5, 9, 7.5, 5.5, 8.5];

  readonly topBarButtons = [0, 1, 2, 3, 4, 5];

  /** Spatial level sections: title width (rem) and year chips. */
  readonly levels = [
    { title: 9, chips: [0, 1, 2, 3, 4] },
    { title: 12, chips: [0, 1, 2, 3] },
  ];
}
